import type { KudoContentObjectDetail, KudoContentObjectList, PublicKudoContentObject } from 'models';
import { ReadMore } from 'ui';
import { KudoRendererBody } from './kudo-renderer-body';

type P = {
  item: KudoContentObjectDetail | KudoContentObjectList | PublicKudoContentObject;
  showReadMore?: boolean;
};

const KudoContentObjectBody = ({ item, showReadMore }: P) => (
  <>
    {showReadMore ? (
      <ReadMore>
        <KudoRendererBody item={item} />
      </ReadMore>
    ) : (
      <KudoRendererBody item={item} />
    )}
  </>
);

export default KudoContentObjectBody;
